// Lightweight context that carries the shared marker action handlers used
// by every marker class (AssetMarker / LocationMarkers / AccessPointMarkers
// / RescueChamberMarkers). Today the only handler is double-click → fly
// camera to that world position. MineScene owns the provider and supplies
// the concrete fly-to function backed by CameraController.

import {createContext, useContext} from 'react'

export interface MarkerActionsValue {
  /** Double-click on any marker → fly camera to this world position. */
  onMarkerDoubleClick: (pos: {x: number; y: number; z: number}) => void
}

const MarkerActionsContext = createContext<MarkerActionsValue>({
  onMarkerDoubleClick: () => {},
})

export const MarkerActionsProvider = MarkerActionsContext.Provider

export function useMarkerActions(): MarkerActionsValue {
  return useContext(MarkerActionsContext)
}
